import React, { FC } from 'react'

import cn from 'clsx'

import { PageNavigation } from '../PageNavigation'
import styles from './PageTemplate.module.scss'
import { PageTemplateProps } from './PageTemplate.types'

export const PageTemplate: FC<PageTemplateProps> = ({
  children,
  navigationProps,
  ...props
}) => {
  return (
    <section {...props} className={cn(styles.pageTemplate, props.className)}>
      {children}
      <PageNavigation {...navigationProps} />
    </section>
  )
}
